"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareResourceComponent = void 0;
var snakeCase_1 = __importDefault(require("lodash/snakeCase"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var PromptInline_1 = require("Common/Prompt/PromptInline");
var Telemetry_1 = require("Telemetry");
var InviteNewUser_1 = require("Common/InviteNewUserModal/InviteNewUser");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var PromptTypes_1 = require("Prompt/PromptTypes");
var PermissionsCard_1 = require("./PermissionsCard/PermissionsCard");
var ShareResourceSearch_1 = require("./ShareResourceSearch/ShareResourceSearch");
var Types_2 = require("../../DataStores/Account/Types");
var PendingUserPermissionsCard_1 = require("../Permissions/PendingUserPermissionsCard/PendingUserPermissionsCard");
var PermissionsDropdown_1 = require("../Permissions/PermissionsDropdown/PermissionsDropdown");
var TransitionGroup_1 = require("./TransitionGroup");
var InviteNewUser_2 = require("../InviteNewUserModal/InviteNewUser");
var PermissionTypes_1 = require("../../DataStores/Permissions/PermissionTypes");
var CollaboratorButton_1 = require("Project/CollaboratorButton");
var ResetCollaboratorLinkButton_1 = __importDefault(require("@CommonFrontend/Project/ResetCollaboratorLinkButton"));
var EntityType;
(function (EntityType) {
    EntityType["Account"] = "account";
    EntityType["Team"] = "team";
    EntityType["User"] = "user";
})(EntityType || (EntityType = {}));
var ShareResourceComponent = (function (_super) {
    __extends(ShareResourceComponent, _super);
    function ShareResourceComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.showError = false;
        _this.errorMessage = "";
        _this.scrollTop = 0;
        _this.resetButtonState = kaleidoscope_3.ButtonState.Idle;
        _this.updateTeamPermission = function (type, permissionAdded) { return function (teamId, permission) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.props.resourceViewStore.updateTeamPermissions(teamId, permission)];
                    case 1:
                        _a.sent();
                        this.firePermissionTelemetry(type, permissionAdded, permission);
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.errorMessage = "Error updating team permissions. Please try again.";
                        this.setShowError(true);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); }; };
        _this.updateUserPermission = function (permissionAdded) { return function (userId, permission) { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.props.resourceViewStore.updateUserPermissions([userId], permission)];
                    case 1:
                        _a.sent();
                        this.firePermissionTelemetry(EntityType.User, permissionAdded, permission);
                        return [3, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.errorMessage = "Error updating user permissions. Please try again.";
                        this.setShowError(true);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); }; };
        _this.firePermissionTelemetry = function (entityType, permissionAdded, permission) {
            if (permissionAdded) {
                _this.props.telemetry.trackOnly("Project Permission Added", {
                    project_permission_added_origin: "search",
                    project_permission_object: entityType,
                    project_permission_type: permission,
                }, { blockIntercom: true });
            }
            else if (permission === Types_1.Action.None) {
                _this.props.telemetry.trackOnly("Project Permission Removed", {
                    project_permission_object: entityType,
                    project_permission_type: permission,
                }, { blockIntercom: true });
            }
            else {
                _this.props.telemetry.trackOnly("Project Permission Updated", {
                    project_permission_object: entityType,
                    project_permission_type: permission,
                }, { blockIntercom: true });
            }
        };
        _this.fireAccountUsersTelemetry = function (origin) {
            _this.props.telemetry.trackOnly("Account Users Viewed", {
                account_users_viewed_origin: origin,
            }, {});
        };
        _this.renderLoader = function () { return (react_1.default.createElement("div", { key: "loader", className: "share-resource__entity-list--loading" },
            react_1.default.createElement(kaleidoscope_3.Spinner, { primary: true, size: "l", message: "Loading team" }))); };
        _this.handleScroll = function (e) {
            _this.scrollTop = e.currentTarget.scrollTop;
        };
        _this.performInvite = function (email, permission) { return __awaiter(_this, void 0, Promise, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.inviteNewUser(email, permission, TelemetryEnums_1.UserInvitedOrigin.TeamSharePanel)];
                    case 1: return [2, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        if (this.shouldShowError(error_1)) {
                            this.errorMessage = "Error inviting user. Please try again.";
                            this.showError = true;
                            throw error_1;
                        }
                        return [2, null];
                    case 3: return [2];
                }
            });
        }); };
        _this.shouldShowError = function (error) {
            if (error && error.message) {
                if (error.message === InviteNewUser_2.ONLY_ADMINS_CAN_INVITE) {
                    return false;
                }
            }
            return true;
        };
        _this.inviteNewUser = (0, InviteNewUser_1.createInviteNewUser)(props.inviteNewUserModal, props.resourceId, props.modal, props.userInvitePermission, props.userDataStore);
        return _this;
    }
    ShareResourceComponent.prototype.setResetButtonState = function (state) {
        this.resetButtonState = state;
    };
    ShareResourceComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.props.telemetry.trackOnly(Telemetry_1.TelemetryEventName.ProjectCollaborateViewed, { clicked_from_source: TelemetryEnums_1.TelemetrySource.Editor }, { blockIntercom: true, blockIdentify: true });
                        return [4, this.props.resourceViewStore.fetchData()];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4, this.props.projectStore.getCollaboratorPageUrlWithGeneration()];
                    case 2:
                        _a.collaboratorLink = _b.sent();
                        return [2];
                }
            });
        });
    };
    ShareResourceComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, resourceViewStore = _a.resourceViewStore, showCollaboratorLink = _a.showCollaboratorLink;
        var showError = this.showError;
        var errorMessage = this.errorMessage;
        var isLoading = true;
        isLoading = resourceViewStore.isLoading;
        if (resourceViewStore.erroredFetching) {
            showError = true;
            errorMessage = "Error loading team. Try refreshing the page.";
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "share-resource__heading" },
                react_1.default.createElement("h4", { className: "share-resource__heading-text" }, "Invite collaborators"),
                react_1.default.createElement(kaleidoscope_3.Link, { href: "/#/settings/users", onClick: function () { return _this.fireAccountUsersTelemetry("team dropdown link"); } }, "Manage teams")),
            showCollaboratorLink && this.renderCopyCollaboratorLink(),
            isLoading && this.renderLoader(),
            !isLoading && (react_1.default.createElement(kaleidoscope_1.ErrorTooltip, { wrapTarget: true, renderTooltip: showError, content: errorMessage, size: kaleidoscope_2.TooltipSize.Large },
                react_1.default.createElement(ShareResourceSearch_1.ShareResourceSearch, { inviteUserToQwilr: this.performInvite, permittedUsers: resourceViewStore.permittedUsers, unpermittedUsers: resourceViewStore.unpermittedUsers, unpermittedTeams: resourceViewStore.unpermittedTeams, updateAccountPermission: this.updateTeamPermission(EntityType.Account, true), updateTeamPermission: this.updateTeamPermission(EntityType.Team, true), updateUserPermission: this.updateUserPermission(true), userInvitePermission: this.props.userInvitePermission, userDataStore: this.props.userDataStore, availablePermissions: this.getAvailablePermissions() }),
                react_1.default.createElement("div", { key: "entities", className: "share-resource__entity-list" },
                    react_1.default.createElement("div", { className: "share-resource__overflow", onScroll: this.handleScroll },
                        react_1.default.createElement(TransitionGroup_1.TransitionGroup, null, this.renderEntityCards())))))));
    };
    ShareResourceComponent.prototype.onCopyCollaboratorLinkClicked = function () {
        var _a;
        this.props.telemetry.trackOnly(Telemetry_1.TelemetryEventName.CollaboratorLinkCopied, (_a = {},
            _a["".concat((0, snakeCase_1.default)(Telemetry_1.TelemetryEventName.CollaboratorLinkCopied), "_source")] = TelemetryEnums_1.TelemetrySource.Editor,
            _a), { blockIntercom: true, blockIdentify: true, includeAuthAttrs: true });
    };
    ShareResourceComponent.prototype.resetCollaboratorLink = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setResetButtonState(kaleidoscope_3.ButtonState.Waiting);
                        return [4, this.props.projectStore.resetCollaboratorPageUrl()];
                    case 1:
                        _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.collaboratorLink = _this.props.projectStore.getCollaboratorPageUrl();
                            _this.resetButtonState = kaleidoscope_3.ButtonState.Idle;
                        });
                        return [2];
                }
            });
        });
    };
    ShareResourceComponent.prototype.renderCopyCollaboratorLink = function () {
        var _this = this;
        var promptHeading = "Collaborator link";
        var promptContent = "Share this link internally for review. Anyone with the collaborator link can view the page. Page views on the collaborator link don't contribute to analytics so it won't interfere with real client data";
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PromptInline_1.PromptInline, { promptId: PromptTypes_1.PromptId.CollaboratorLink, heading: promptHeading, content: promptContent }),
            react_1.default.createElement(CollaboratorButton_1.CollaboratorButton, { collaboratorLink: this.collaboratorLink, buttonState: this.resetButtonState, telemetryCallback: function () { return _this.onCopyCollaboratorLinkClicked(); }, width: "full" }),
            react_1.default.createElement("div", { className: "text-description share-resource__copy-link-description" },
                "Anyone with the collaborator link can view.",
                " ",
                react_1.default.createElement(ResetCollaboratorLinkButton_1.default, { onReset: function () { return _this.resetCollaboratorLink(); } }),
                " to revoke access from anyone with the current link.")));
    };
    ShareResourceComponent.prototype.renderEntityCards = function () {
        var _this = this;
        var resourceViewStore = this.props.resourceViewStore;
        var renderHr = true;
        var availablePermissions = this.getAvailablePermissions();
        var permittedTeams = resourceViewStore.permittedTeams;
        var permittedUsers = resourceViewStore.permittedUsers;
        var hasUsers = permittedUsers.length > 0;
        var teamCards = permittedTeams.map(function (team, index) {
            if (!hasUsers && index + 1 === permittedTeams.length) {
                renderHr = false;
            }
            if (team.type === Types_2.TeamType.Account) {
                return (react_1.default.createElement("div", { key: team.id },
                    react_1.default.createElement(PermissionsCard_1.AccountPermissionsCard, { id: team.id, permission: team.permission, handlePermissionChange: _this.updateTeamPermission(EntityType.Account, false), scrollTop: _this.scrollTop, availablePermissions: availablePermissions, inheritedPermission: team.inheritedPermission }),
                    renderHr && react_1.default.createElement("hr", null)));
            }
            return (react_1.default.createElement("div", { key: team.id },
                react_1.default.createElement(PermissionsCard_1.TeamPermissionsCard, { id: team.id, name: team.name, permission: team.permission, handlePermissionChange: _this.updateTeamPermission(EntityType.Team, false), scrollTop: _this.scrollTop, availablePermissions: availablePermissions }),
                renderHr && react_1.default.createElement("hr", null)));
        });
        var userCards = permittedUsers.map(function (user, index) {
            if (index + 1 === permittedUsers.length) {
                renderHr = false;
            }
            return _this.renderUserCard(user, renderHr);
        });
        return __spreadArray(__spreadArray([], __read(teamCards), false), __read(userCards), false);
    };
    ShareResourceComponent.prototype.renderUserCard = function (user, shouldRenderHr) {
        var availablePermissions = this.getAvailablePermissions();
        var showIsAdmin = this.props.adminsHavePrivilege && user.role === Types_1.Role.Admin;
        switch (user.type) {
            case PermissionTypes_1.UserType.Existing:
                var ownerUserId = this.props.ownerUserId;
                var isOwner = !!ownerUserId && user.id === ownerUserId;
                var permissionsSlot = (0, PermissionsCard_1.createUserPermissionsSlot)(user.id, this.updateUserPermission(false), user.permission, showIsAdmin, this.scrollTop, availablePermissions, isOwner);
                return (react_1.default.createElement("div", { key: user.email },
                    react_1.default.createElement(TransitionGroup_1.TransitionGroup, null,
                        react_1.default.createElement(PermissionsCard_1.UserPermissionsCard, { firstName: user.firstName, lastName: user.lastName || "", email: user.email, permissionsSlot: permissionsSlot }),
                        shouldRenderHr && react_1.default.createElement("hr", { key: "user-card-hr-".concat(user.email) }))));
            case PermissionTypes_1.UserType.Pending:
                return (react_1.default.createElement("div", { key: user.email },
                    react_1.default.createElement(TransitionGroup_1.TransitionGroup, null,
                        react_1.default.createElement(PendingUserPermissionsCard_1.PendingUserPermissionsCard, { email: user.email, permissionsDropdown: this.renderPermissionsDropdown(user) }),
                        shouldRenderHr && react_1.default.createElement("hr", { key: "hr-user.email" }))));
            default:
                throw new Error("Unknown UserPermissionType: ".concat(JSON.stringify(user)));
        }
    };
    ShareResourceComponent.prototype.renderPermissionsDropdown = function (user) {
        return (react_1.default.createElement(PermissionsDropdown_1.PermissionsDropdown, { handlePermissionChange: this.updateUserPermission(false), entityId: user.id, directPermission: user.permission, scrollTop: this.scrollTop, availablePermissions: this.getAvailablePermissions() }));
    };
    ShareResourceComponent.prototype.setShowError = function (showError) {
        var _this = this;
        this.showError = showError;
        if (showError) {
            setTimeout(function () {
                _this.setShowError(false);
            }, kaleidoscope_1.ErrorTooltipTimeout);
        }
    };
    ShareResourceComponent.prototype.getAvailablePermissions = function () {
        var availablePermissions = this.props.resourceViewStore.availablePermissions;
        if (!availablePermissions) {
            availablePermissions = [Types_1.Action.Edit, Types_1.Action.View];
        }
        return availablePermissions;
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ShareResourceComponent.prototype, "showError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ShareResourceComponent.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ShareResourceComponent.prototype, "scrollTop", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], ShareResourceComponent.prototype, "collaboratorLink", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof kaleidoscope_3.ButtonState !== "undefined" && kaleidoscope_3.ButtonState) === "function" ? _a : Object)
    ], ShareResourceComponent.prototype, "resetButtonState", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof kaleidoscope_3.ButtonState !== "undefined" && kaleidoscope_3.ButtonState) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], ShareResourceComponent.prototype, "setResetButtonState", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ShareResourceComponent.prototype, "setShowError", null);
    ShareResourceComponent = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ShareResourceComponent);
    return ShareResourceComponent;
}(react_1.default.Component));
exports.ShareResourceComponent = ShareResourceComponent;
